define('googlemaps',[], function () {
  var __initialized = false;

  return function googleMaps() {
    return new Promise(function (resolve, reject) {
      if (__initialized && window.google) {
        resolve(window.google);
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8';
      script.async = true;
      script.onload = function () {
        __initialized = true;
        resolve(window.google);
      };
      script.onerror = function (err) {
        reject(err);
      };
      document.head.appendChild(script);
    });
  };
});

